import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"

export default class extends Controller {
  static targets = ["display", "input", "error"]
  static values = { url: String, name: String }

  connect() {
    this.originalContent = this.displayTarget.innerText.trim(); // Store original value for cancel/revert
  }

  // Switch to edit mode
  edit() {
    if (!this.hasDisplayTarget || !this.hasInputTarget) return;

    this.originalContent = this.displayTarget.innerText.trim();
    this.displayTarget.classList.add("hidden");
    this.inputTarget.classList.remove("hidden");
    this.inputTarget.value = this.originalContent === "-" ? "" : this.originalContent;
    this.inputTarget.focus();
    this.hideError();
  }

  // Save changes (Enter) or cancel (Escape)
  async update(event) {
    if (event.type === "keydown" && !["Enter", "Escape"].includes(event.key)) return;
    if (event.key === "Escape") return this.cancel();

    const newValue = this.inputTarget.value.trim();

    // Skip if no change
    if (newValue === this.originalContent || (newValue === "" && this.originalContent === "-")) {
      return this.cancel();
    }

    // Optimistic UI update
    this.displayTarget.innerText = newValue || "-";
    this.cancel();
    this.hideError();

    try {
      // Send PATCH request
      const response = await patch(this.urlValue, {
        body: JSON.stringify({ [this.nameValue]: newValue }),
        responseKind: "json",
        contentType: "application/json"
      });

      if (!response.ok) throw new Error("Bad response");

      const data = await response.json;
       // Handle server-side errors
      if (!data.success) {
        this.displayTarget.innerText = this.originalContent || "-";
        this.showError(`Update failed: ${data.errors.join(', ')}`);
      }
    } catch (error) {
      console.error("Error:", error);
      this.displayTarget.innerText = this.originalContent || "-";
      this.showError("An error occurred during the update.");
    }
  }

  // Cancel edit mode
  cancel() {
    if (!this.hasDisplayTarget || !this.hasInputTarget) return;
    this.displayTarget.classList.remove("hidden");
    this.inputTarget.classList.add("hidden");
    this.hideError();
  }

  // Show error message
  showError(message) {
    if (this.hasErrorTarget) {
      this.errorTarget.innerText = message;
      this.errorTarget.classList.remove("hidden");
    }
  }

  // Hide error message
  hideError() {
    if (this.hasErrorTarget) {
      this.errorTarget.innerText = "";
      this.errorTarget.classList.add("hidden");
    }
  }
}
